import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { routePaths } from "../config/route-paths";
import { LandingComponent } from "../landing/landing-component";
import BalancePage from "../e_quick-pay/e_view-balance-page/e_view-balance";
import  E_RazorPaymentConfirmation from "../e_quick-pay/e_payment/e_razor-pay/e_razor-payment-confirmation";
import E_QuickPay from "../e_quick-pay/e_quick-pay-landing-page/e_quick-pay";
import { TermsCondition } from "../terms-condition/terms-condition";
import RetryPage from "../retry/retry-component";
import EHomePage from "../e_home-page/e_home-page";
import SearchResults from "../home-page/search/search";
import Faqs from "../home-page/faqs/faq";
import Announcements from "../home-page/announcement/announce";
import ELogin from "../e_home-page/e_login-section/e_login/view/_login";
import ERegister from "../e_home-page/e_register/e_register"
import ERegisterSuccess from "../e_home-page/e_Succes-section/e_register_success";
import EForgot_Password from "../e_home-page/e_login-section/e_forgot-password/e_forgot-password";
import EVerifyOTP from "../e_home-page/e_verify_register_otp/view/_verify-otp-page";
import ESendOtp from "../e_home-page/e_login-section/e_send-otp/view/_send-otp";
import EVerificationFailure from "../e_home-page/e_register/e_verification_failed/_e_verification_failed";
import ENewConnectionRequest from "../e_new-connection/e_new-connection-request";
import TrackingLandingPage from "../e_tracking-new-connection/e_tracking-landing-page/view/tracking-request_landing_page";
import TrackingStepsPage from "../e_tracking-new-connection/e_tracking-pages/tracking-request"
import E_BkashPaymentConfirmation from "../e_quick-pay/e_payment/e_bkash/e_payment_confirmation";
import EUserMigration from "../e_user_migration/_user_migration";
import EOneTimePayments from "../e_one_time_payments/_one_time_payments";
import PrivacyPolicy from "../privacy-policy/privacy-policy";

const Routes = () => {
  return (
    <Switch>
      <Route exact path={routePaths.QUICK_PAY} component={E_QuickPay} />
      <Route exact path={routePaths.FAQS} component={Faqs} />
      <Route exact path={routePaths.ANNOUNEMENT} component={Announcements} />
      <Route exact path={routePaths.LANDING} component={LandingComponent} />
      {/* <Route path={routePaths.TRACK_REQUEST} component={TrackingLandingPage} /> */}
      {/* <Route  path={routePaths.TRACK_REQUEST_STEPS} component={TrackingStepsPage} /> */}
      <Route path={routePaths.VIEW_BALANCE} component={BalancePage} />
      <Route path={routePaths.PAYMENT} component={E_BkashPaymentConfirmation} />
      <Route path={routePaths.PAYMENT_BILLPAY} component={E_RazorPaymentConfirmation} />
      <Route path={routePaths.TERMS_CONDITION} component={TermsCondition} />
      <Route path={routePaths.RETRY} component={RetryPage} />
      {/* <Route path={routePaths.NCR} component={ENewConnectionRequest} /> */}
      <Route path={routePaths.SEARCH_RESULTS} component={SearchResults} />
      <Route exact path={routePaths.MIGRATE_USER} component={EUserMigration} />
      <Route path={routePaths.ONE_TIME_PAYMENTS} component={EOneTimePayments} />
      <Route path={routePaths.PRIVACY_POLICY} component={PrivacyPolicy} />
      <Route exact path='*' component={EHomePage} />
      <Redirect from="*" to={routePaths.LOGIN} />

    </Switch>
  );
};
 
export default Routes;
 
export const HomeRoutes = () => {
  return (
    <Switch>
      <Route exact path={routePaths.LOGIN} component={ELogin} />
      <Route exact path={routePaths.REGISTER} component={ERegister} />
      <Route exact path={routePaths.SIGN_UP_VERIFY_OTP} component={EVerifyOTP} />
      <Route exact path={routePaths.ACTIVATE_EMAIL} component={ERegisterSuccess} />
      <Route exact path={routePaths.FORGOT_PASSWORD} component={EForgot_Password}/>
      <Route exact path={routePaths.LOGIN_VIA_OTP} component={ESendOtp}/>
      <Route exact path={routePaths.LOGIN_VERIFY_OTP} component={EVerifyOTP} />
      <Route exact path ={routePaths.SIGN_UP_VERIFICATION_FAIL} component={EVerificationFailure}/>
      <Redirect from="*" to={routePaths.LOGIN} />
    </Switch>
  );
};

